// @类型 - type
// 申请季、当季：apply 正常: normal 早期鸟: earlyBird
// 1.申请季、当季——2019、2020；
// 2.正常——2021；
// 3.早起鸟——2022及以后
// 4. 长线包括正常和早起鸟
// ----------------------------------------
// @套餐类型 - packageType
// AEGIS, 黑金
// PREMIER, 菁英
// PREMIER_ART, 菁英-艺术类
// CLASSIC, 至领
// CLASSIC_ART, 至领-艺术类
// DEVELOPMENT, 飞跃
// CLASSICLITE, 启航
// DEVELOPMENTLITE,轻享
// ----------------------------------------
// @plan - plan
// PLANA,
// PLANB,
// PLANC,暂时不考虑
// SCHOLAR
export default [
  {
    type: 'apply',
    plan: 'PLANA',
    title: '客户手册（申请季版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.1%202019%C2%A0%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%C2%A0%EF%BC%88%E7%94%B3%E8%AF%B7%E5%AD%A3%E7%89%88%EF%BC%89v1.0%20(secured).pdf'
  },
  {
    type: '',
    plan: 'PLANA',
    packageType: 'AEGIS',
    title: '产品指南 黑金计划 Aegis',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.2%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%20v1.0%20(secured).pdf'
  },
  {
    type: '',
    plan: 'PLANA',
    packageType: 'PREMIER',
    title: '产品指南 菁英计划 Premier',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.3%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92%20Premier%20v1.0%20(secured).pdf'
  },
  {
    type: 'apply',
    plan: 'PLANA',
    packageType: 'CLASSIC',
    title: '产品指南 至领计划 Classic',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.4%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20v1.0%20(secured).pdf'
  },
  {
    type: 'apply',
    plan: 'PLANA',
    packageType: 'DEVELOPMENT',
    title: '产品指南 飞跃计划 Development',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.5%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%A3%9E%E8%B7%83%E8%AE%A1%E5%88%92%20Development%20v1.0%20(secured).pdf'
  },
  {
    type: 'apply',
    plan: 'PLANA',
    packageType: 'CLASSICLITE',
    title: '产品指南 启航计划 Classic Lite',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.6%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%20v1.0%20(secured).pdf'
  },
  {
    type: 'apply',
    plan: 'PLANA',
    packageType: 'DEVELOPMENTLITE',
    title: '产品指南 轻享计划 Development Lite',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.7%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%BD%BB%E4%BA%AB%E8%AE%A1%E5%88%92%20Development%20Lite%20v1.0%20(secured).pdf'
  },
  {
    type: 'earlyBird',
    plan: 'PLANA',
    packageType: 'CLASSIC',
    title: '产品指南 至领计划 Classic（早起鸟版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.9%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20%EF%BC%88%E6%97%A9%E8%B5%B7%E9%B8%9F%E7%89%88%EF%BC%89%20v1.0%20(secured).pdf'
  },
  {
    type: 'earlyBird',
    plan: 'PLANA',
    title: '客户手册（B）（长线学员版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.99%202019%C2%A0%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%C2%A0(B)%EF%BC%88%E9%95%BF%E7%BA%BF%E5%AD%A6%E5%91%98%E7%89%88%EF%BC%89v1.0%20(secured).pdf'
  },
  {
    type: 'normal',
    plan: 'PLANA',
    title: '客户手册（B）（长线学员版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.99%202019%C2%A0%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%C2%A0(B)%EF%BC%88%E9%95%BF%E7%BA%BF%E5%AD%A6%E5%91%98%E7%89%88%EF%BC%89v1.0%20(secured).pdf'
  },
  {
    type: 'normal',
    plan: 'PLANA',
    packageType: 'CLASSIC',
    title: '产品指南 至领计划 Classic（正常版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.91%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20%EF%BC%88%E6%AD%A3%E5%B8%B8%E7%89%88%EF%BC%89%20v1.0%20(secured).pdf'
  },
  {
    type: 'earlyBird',
    plan: 'PLANA',
    packageType: 'CLASSICLITE',
    title: '产品指南 启航计划 Classic Lite（早起鸟版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.92%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%EF%BC%88%E6%97%A9%E8%B5%B7%E9%B8%9F%E7%89%88%EF%BC%89%20v1.0%20(secured).pdf'
  },
  {
    type: 'normal',
    plan: 'PLANA',
    packageType: 'CLASSICLITE',
    title: '产品指南 启航计划 Classic Lite（正常版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/plana/1.93%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%EF%BC%88%E6%AD%A3%E5%B8%B8%E7%89%88%EF%BC%89%20v1.0%20(secured).pdf'
  },
  {
    type: '',
    plan: 'PLANA',
    packageType: 'PREMIER_ART',
    title: '2019 产品指南 (A) 菁英计划-艺术类 Premier v1.0',
    url:
        'https://res.zailairen.com/msp/docs/1.0/plana/2019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%28A%29%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92-%E8%89%BA%E6%9C%AF%E7%B1%BB%20Premier%20v1.0.pdf'
  },
  {
    type: '',
    plan: 'PLANB',
    packageType: 'CLASSIC_ART',
    title: '2019 产品指南 (B) 至领计划-艺术类 Classic v1.0',
    url:
        'https://res.zailairen.com/msp/docs/1.0/planb/2019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%28B%29%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92-%E8%89%BA%E6%9C%AF%E7%B1%BB%20Classic%20v1.0.pdf'
  },
  {
    type: 'apply',
    plan: 'PLANB',
    title: '客户手册（B）（申请季版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.94%202019%C2%A0%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%C2%A0(B)%EF%BC%88%E7%94%B3%E8%AF%B7%E5%AD%A3%E7%89%88%EF%BC%89v1.0%20(secured).pdf'
  },
  {
    type: '',
    plan: 'PLANB',
    packageType: 'AEGIS',
    title: '产品指南（B）黑金计划 Aegis',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.95%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20(B)%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20v1.0%20(secured).pdf'
  },
  {
    type: '',
    plan: 'PLANB',
    packageType: 'PREMIER',
    title: '产品指南（B）菁英计划 Premier',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.96%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20(B)%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92%20Premier%20v1.0%20(secured).pdf'
  },
  {
    type: 'apply',
    plan: 'PLANB',
    packageType: 'CLASSIC',
    title: '产品指南（B）至领计划 Classic',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.97%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20(B)%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20v1.0%20(secured).pdf'
  },
  {
    type: 'apply',
    plan: 'PLANB',
    packageType: 'CLASSICLITE',
    title: '产品指南（B）启航计划 Classic Lite',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.98%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20(B)%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%20%20v1.0%20(secured).pdf'
  },
  {
    type: 'earlyBird',
    plan: 'PLANB',
    title: '客户手册（B）（长线学员版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.99%202019%C2%A0%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%C2%A0(B)%EF%BC%88%E9%95%BF%E7%BA%BF%E5%AD%A6%E5%91%98%E7%89%88%EF%BC%89v1.0%20(secured).pdf'
  },
  {
    type: 'normal',
    plan: 'PLANB',
    title: '客户手册（B）（长线学员版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.99%202019%C2%A0%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%C2%A0(B)%EF%BC%88%E9%95%BF%E7%BA%BF%E5%AD%A6%E5%91%98%E7%89%88%EF%BC%89v1.0%20(secured).pdf'
  },
  {
    type: 'earlyBird',
    plan: 'PLANB',
    packageType: 'CLASSIC',
    title: '产品指南（B）至领计划 Classic（早起鸟版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.991%202018%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20(B)%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20%EF%BC%88%E6%97%A9%E8%B5%B7%E9%B8%9F%E7%89%88%EF%BC%89%20v3.0%20(secured).pdf'
  },
  {
    type: 'normal',
    plan: 'PLANB',
    packageType: 'CLASSIC',
    title: '产品指南（B）至领计划 Classic（正常版版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.992%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20(B)%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20%EF%BC%88%E6%AD%A3%E5%B8%B8%E7%89%88%EF%BC%89%20v1.0%20(secured).pdf'
  },
  {
    type: 'earlyBird',
    plan: 'PLANB',
    packageType: 'CLASSICLITE',
    title: '产品指南（B）启航计划 Classic Lite（早起鸟版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.993%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20(B)%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%20%EF%BC%88%E6%97%A9%E8%B5%B7%E9%B8%9F%E7%89%88%EF%BC%89%20v1.0%20(secured).pdf'
  },
  {
    type: 'normal',
    plan: 'PLANB',
    packageType: 'CLASSICLITE',
    title: '产品指南（B）启航计划 Classic Lite（正常版）',
    url:
      'https://res.zailairen.com/msp/docs/1.0/planb/1.994%202019%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20(B)%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%20%EF%BC%88%E6%AD%A3%E5%B8%B8%E7%89%88%EF%BC%89%20v1.0%20(secured).pdf'
  },
  {
    type: '',
    plan: '',
    packageType: 'SCHOLAR',
    title: '2021 奖学金项目手册 v3.0 (secured)',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E5%A5%96%E5%AD%A6%E9%87%91%E9%A1%B9%E7%9B%AE%E6%89%8B%E5%86%8C%20v3.0%20%28secured%29.pdf'
  },
  {
    type: '',
    plan: 'CLASSIC',
    packageType: 'SCHOLAR',
    title: '2021 奖学金项目产品指南 至领计划 Classic v3.0 (secured)',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E5%A5%96%E5%AD%A6%E9%87%91%E9%A1%B9%E7%9B%AE%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20v3.0%20%28secured%29.pdf'
  },
  {
    type: '',
    plan: 'CLASSICLITE',
    packageType: 'SCHOLAR',
    title: '2021 奖学金项目产品指南 启航计划 Classic Lite v3.0 (secured)',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E5%A5%96%E5%AD%A6%E9%87%91%E9%A1%B9%E7%9B%AE%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%20v3.0%20%28secured%29.pdf'
  }
]
